import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";

export class BFStackedRespinZeroBetController extends RespinZeroBetController {
    private _mode:string;

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        let isZeroBet:boolean = ((data.nextMode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN) ||
            (data.nextMode === BarbarianFuryGameMode.STACKED_RESPIN) ||
            (data.mode === BarbarianFuryGameMode.STACKED_RESPIN_FREESPIN)) && data.nextMode !== BarbarianFuryGameMode.NORMAL;
        this._mode = data.mode;
        return isZeroBet;
    }

    public shouldShowZeroBetCounter():boolean {
        if(this._mode.indexOf("FREESPIN") !== -1) {
            return true;
        }
        return false;
    }
}